import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const MinusIcon = createIcon({
  displayName: 'MinusIcon',
  path: (
    <path
      d='M18.25 12.25H5.75'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ),
  defaultProps: defaultProps
})
